import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./footer.css";

export default class Footer extends Component {
	constructor() {
      super();
			this.state={

  }
	}
	render() {
		return (
      <div>
        
        <div className="yelp-background small-padding">
            <div className="row" style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}>

                <div className="small-12 medium-9" style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center"
                }}>
                  <img className="icon-100" style={{width: "100px"}} src="/images/yelp-logo.png" />
                  <div>  
                    <h2 className="white no-margin small-centered-text">Visit Us On Yelp!</h2>
                    <p className="white subheading small-centered-text medium-margin-bottom no-margin-top">Average Rating of 5 out of 5 stars on yelp</p>
                  </div>
                </div>
                <div className="small-12 medium-3 row">
                    <a  className="button white-background yelp-color center-position" target="_blank" href="https://www.yelp.com/biz/pacific-garage-doors-half-moon-bay-2" style={{
                        backgroundColor: "#fff",
                        color: "#c60c00",
                        padding: "12px 40px",
                        borderRadius: "4px",
                        textDecoration: "none",
                        fontWeight: "bold"
                    }}>Check Us Out</a>
                </div>
            </div>
        </div>
        <div className="row footer layout-1 dark primary-background medium-padding" style={{paddingBottom: "250px"}}>
            <div className="medium-12 columns centered-text full-width">
                <img className="full-width" style={{maxWidth: "150px", marginBottom: "20px"}} src="/images/logo.png" />
                <p className="subheading white">Pacific Garage Doors Inc All Rights Reserved</p>
            	<p className="subheading small-centered-text full-width white">
            		<Link to="/" className="white" style={{color: "#fff", textDecoration: "none", transition: "opacity 0.3s ease"}} onMouseEnter={(e) => e.target.style.opacity = "0.7"} onMouseLeave={(e) => e.target.style.opacity = "1"}>Home</Link>   |   <Link to="/portfolio" className="white" style={{color: "#fff", textDecoration: "none", transition: "opacity 0.3s ease"}} onMouseEnter={(e) => e.target.style.opacity = "0.7"} onMouseLeave={(e) => e.target.style.opacity = "1"}>Portfolio</Link>   |    <Link to="/testimonials" className="white" style={{color: "#fff", textDecoration: "none", transition: "opacity 0.3s ease"}} onMouseEnter={(e) => e.target.style.opacity = "0.7"} onMouseLeave={(e) => e.target.style.opacity = "1"}>Testimonials</Link>    |    <Link to="/contact" className="white" style={{color: "#fff", textDecoration: "none", transition: "opacity 0.3s ease"}} onMouseEnter={(e) => e.target.style.opacity = "0.7"} onMouseLeave={(e) => e.target.style.opacity = "1"}>Contact Us</Link>
            	</p>
                <p className="white" style={{marginTop: "20px"}}><b>Lic #837295</b> Bonded and Insured</p>
            </div>
        </div>
      </div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/footer/index.js